import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIcon } from '@ng-icons/core';
import { APP_CONFIG_TOKEN, createContactUsHref } from '@quipex/core/config';
import {
    DocumentStorageUsage,
    getDocumentStorageCapacityStatus,
} from '@quipex/feature/building-context';
import type { GetBuildingDocumentStorageUsageResponse } from '@quipex/shared/contracts';
import {
    QpxButton,
    QpxHeroIcon,
    QpxIcon,
    QpxTypography,
} from '@quipex/shared/ui';

@Component({
    selector: 'qpx-preview-storage-capacity-banner',
    imports: [
        DocumentStorageUsage,
        MatButtonModule,
        NgIcon,
        QpxButton,
        QpxHeroIcon,
        QpxIcon,
        QpxTypography,
    ],
    templateUrl: './preview-storage-capacity-banner.html',
    styleUrl: './preview-storage-capacity-banner.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'status',
        'aria-label': 'Document storage capacity',
    },
})
export class PreviewStorageCapacityBanner {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    public readonly storageUsage =
        input.required<GetBuildingDocumentStorageUsageResponse>();

    protected readonly isFull = computed(
        () => getDocumentStorageCapacityStatus(this.storageUsage()) === 'full'
    );
    protected readonly contactUsHref = createContactUsHref(
        this.appConfig.supportEmail
    );
}
